(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ModalCampaignSettingsContentController', ModalCampaignSettingsContentController);

    /** @ngInject */
    function ModalCampaignSettingsContentController(CampaignService, toastr, $translate) {
        var vm = this;

        vm.campaignSellerLimit = null;
        vm.isLoading = false;

        vm.$onInit = init;
        vm.save = save;

        vm.isFormInvalid = function () {
            return vm.campaignSettingsForm && vm.campaignSettingsForm.$invalid;
        };

        function init() {
            vm.isLoading = true;
            CampaignService.getCampaignSettings()
                .then(function (response) {
                    vm.campaignSellerLimit = (response && response.campaignSellerLimit != null)
                        ? response.campaignSellerLimit
                        : null;
                    vm.isLoading = false;
                })
                .catch(function () {
                    vm.isLoading = false;
                    toastr.error($translate.instant('campaign.settings.messages.error-loading'));
                });
        }

        function save() {
            var limit = (vm.campaignSellerLimit === null || vm.campaignSellerLimit === undefined || vm.campaignSellerLimit === '')
                ? null
                : parseInt(vm.campaignSellerLimit, 10);

            CampaignService.saveCampaignSettings({ campaignSellerLimit: limit })
                .then(function () {
                    toastr.success($translate.instant('campaign.settings.messages.success'));
                })
                .catch(function () {
                    toastr.error($translate.instant('campaign.settings.messages.error'));
                });
        }
    }
})();
